module.exports = __webpack_public_path__ + "static/media/stopSmall.cb1f938e.svg";